import { API } from '../../../api';
export default function UserListItem({ item, onHover, onEdit, onDelete }) {
  const getImageUrl = (baseUrl=API.API_LINK + "/") => {
    if (item.image_source === "web") return item.image_name;
    if (!item.image_name || !item.image_extension) return null;
    return `${baseUrl}file/pictures/avatars/source/${item.image_name}.${item.image_extension}`;
  };

  return (
    <li className="carrousel-list-item" onMouseEnter={() => onHover?.(item)}>
    	<div className="item-info">
        	<div className="item-thumb">
          		{getImageUrl() ? (
            		<img src={getImageUrl()} alt={item.image_name || "Image"} onError={e => e.target.style.display = "none"} />
          		) : (
            		<div className="empty-thumb fdgdfgdgdg"><span>📷</span></div>
          		)}
        	</div>

        	<div className="item-details">
          		<h4>{item.last_name || "Sans nom"} {item.first_name || "Sans prénom"}</h4>
          		<p className="item-event">{item.email}</p>
          		<p className="item-visibility">{item.isvisible ? "✓ Commande en cours" : "✗ 0 commande en cours"}</p>
        	</div>
      	</div>

      	<div className="item-actions">
        	<button className="btn-icon btn-edit" onClick={() => onEdit(item)} title="Modifier">✏️</button>
        	<button className="btn-icon btn-delete" onClick={() => onDelete(item)} title="Supprimer">🗑️</button>
      	</div>
    </li>
  );
}